var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayoutTopWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.70589H16M5.73333 2.11765H12.2667C13.5735 2.11765 14.2268 2.11765 14.726 2.36768C15.165 2.58763 15.522 2.93858 15.7457 3.37025C16 3.861 16 4.50341 16 5.78824V12.2118C16 13.4966 16 14.1391 15.7457 14.6297C15.522 15.0615 15.165 15.4123 14.726 15.6324C14.2268 15.8824 13.5735 15.8824 12.2667 15.8824H5.73333C4.42654 15.8824 3.77315 15.8824 3.27403 15.6324C2.83498 15.4123 2.47803 15.0615 2.25432 14.6297C2 14.1391 2 13.4966 2 12.2118V5.78824C2 4.50341 2 3.861 2.25432 3.37025C2.47803 2.93858 2.83498 2.58763 3.27403 2.36768C3.77315 2.11765 4.42654 2.11765 5.73333 2.11765Z",
    stroke: "white",
    strokeWidth: 1.34001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutTopWhite);
export default __webpack_public_path__ + "static/media/layout-top-white.8b74c5b39da27da4df0aa48b90089ac0.svg";
export { ForwardRef as ReactComponent };